'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _index = require('./reducers/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _redux.createStore)(_index2.default, {
  currentTask: {
    content: null,
    style: null,
    alpha: 0.001
  },
  tasks: [],
  folders: {
    newFolder: {},
    folders: [],
    openFolders: []
  },
  audioPlayer: {
    file: null
  }
});

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./client/store.js
// module id = 38
// module chunks = 0